<template>
  <!-- <v-container padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);> -->
  <div v-iosSafeArea>
    <v-app>
      <!-- Main Navigation Drawer -->
      <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
        temporary
        right
      >
        <!-- Menu Header with Avatar -->
        <template v-slot:prepend>
          <v-list-item two-line>
            <v-list-item-avatar>
              <img alt="OUG" :src="getAvatar()" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="ml-n10" v-if="loggedIn"
                >{{ currentUser.Firstname }} {{ currentUser.Surname }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-divider></v-divider>
        <!-- Menu List -->
        <v-list id="mainlist">
          <template v-for="item in menu">
            <v-row v-if="item.heading" :key="item.heading" align="start">
              <v-col cols="6">
                <v-subheader v-if="item.heading">
                  {{ item.heading }}
                </v-subheader>
              </v-col>
              <v-col cols="6" class="text-center">
                <a href="#!" class="body-2 black--text">EDIT</a>
              </v-col>
            </v-row>
            <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon=""
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title align="start">
                    {{ item.text }}</v-list-item-title
                  >
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                :to="child.action"
                link
                @click="slideDraw()"
              >
                <v-list-item-action v-if="child.icon" class="ml-6">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title align="start">
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="item.text"
              :to="item.action"
              @click="slideDraw()"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title align="start">
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <v-divider class="mb-3"></v-divider>
        <v-spacer></v-spacer>
        <template>
          <div class="pa-1">
            <!-- <v-btn
              v-if="this.assocName != null"
              class="mb-2"
              color="oug"
              block
              outlined
              to="/MyAssoc"
              @click="slideDraw"
              >My Association</v-btn
            > -->
            <v-btn
              class="mb-2"
              color="oug"
              block
              outlined
              to="/Account"
              @click="slideDraw"
              >My Account</v-btn
            >
            <!-- <v-btn color="oug" block dark to="/login" @click="logout"> -->
            <v-btn color="oug" block dark @click="logoutDialog = true">
              Logout
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
      <v-dialog v-model="logoutDialog" max-width="500px">
        <v-card>
          <v-card-text>
            <p></p>
            <h3>Are you sure you want to log out?</h3>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="logoutDialog = false">
              Close
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn to="/" @click="logout" color="oug" dark>Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Main App Bar -->
      <!-- :clipped-left="this.$vuetify.breakpoint.lgAndUp" -->
      <v-app-bar
        :clipped-left="this.$vuetify.breakpoint.lgAndUp"
        :clipped-right="this.$vuetify.breakpoint.lgAndUp"
        app
        color="oug"
        dark
        dense
        elevate-on-scroll
        elevation="24"
      >
        <v-btn
          v-if="!$route.meta.hideNavigation"
          color="oug"
          dark
          @click="goBack"
          >BACK</v-btn
        >
        <v-col class="d-flex justify-space-around mt-2">
          <v-toolbar-title v-if="!$route.meta.hideNavigation" class="mr-10">{{
            title
          }}</v-toolbar-title>
          <v-toolbar-title v-if="$route.meta.hideNavigation">{{
            title
          }}</v-toolbar-title>
        </v-col>
        <!-- App Bar at top of Screen -->
        <v-app-bar-nav-icon
          v-if="!$route.meta.hideNavigation"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
      </v-app-bar>

      <v-main class="mt-10">
        <router-view></router-view>
      </v-main>

      <!-- App Footer -->
      <Footer :title="title" />
    </v-app>
  </div>
</template>

<script>
import { authComputed, getUser } from "./veux/helpers.js";
import Footer from "./common/Components/Footer";
// import Profile from "./common/Components/Profile";
// import MainNav from "./common/Components/MainNav";
import Settings from "./data/Settings";
import db from "./data/Database";

export default {
  name: "App",
  components: {
    Footer,
    // Profile,
    // MainNav,
  },
  props: {
    source: String,
  },
  data: () => ({
    assocName: "",
    drawer: null,
    profile: null,
    title: Settings.Title,
    menu: Settings.MainMenu,
    logoutDialog: false,
  }),
  mount() {},
  created() {
  },
  methods: {
    loadAccess() {
      console.log("Here")
      this.access = [];
      db.Access.toArray((result) => this.validateAccess(result));
    },

    validateAccess(result) {
      this.access = result;
      this.access.forEach((element) => {
        // console.log(element)
        if (element.LinkType === 'Associations') {
          this.assocName = element.Detail;
        }
        else
        {
          this.assocName = "Test";
        }
      });
      console.log("Assoc Name: ", this.assocName);
    },
    

    getAvatar() {
      // Set default to not logged in
      let result = require("./assets/no_profile_picture.png"); //require('./assets/logo.png')
      if (this.loggedIn) {
        // if logged in then check Profile photo
        if (this.currentUser.Photo) {
          result = `https://admin.ownurgoal.net.au/_lib/file/OUGImages/${this.currentUser.Photo}`;
        }
      }
      return result;
    },

    closeDraws() {
      // Close the NavBars
      this.drawer = false;
      this.profile = false;
    },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    logout() {
      this.$store.dispatch("logout");
      db.Access.clear();
      console.log("database clear stage")
      this.logoutDialog = false;
    },
    slideDraw() {
      this.$emit("closeDraw");
    },
    currentView() {
      if (this.$router.history.current.fullPath == "/") {
        return false;
      } else {
        return true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...getUser,
  },
};
</script>

<style lang="scss">
@import "./assets/styles/global.scss";
.copy {
  font-size: 10px;
}

.v-navigation-drawer {
  top: env(safe-area-inset-top) !important;
  margin-left: env(safe-area-inset-left) !important;
  margin-right: env(safe-area-inset-right) !important;
  bottom: env(safe-area-inset-bottom) !important;
}

.v-app-bar {
  top: env(safe-area-inset-top) !important;
  left: env(safe-area-inset-left) !important;
}

body {
padding-top: constant(safe-area-inset-top); /* iOS 11.0 */
padding-top: env(safe-area-inset-top); /* iOS 11.2 */
}


.v-app {
  margin-top: env(safe-area-inset-top) !important;
  margin-left: env(safe-area-inset-left) !important;
  margin-right: env(safe-area-inset-right) !important;
  margin-bottom: env(safe-area-inset-bottom) !important;
}
</style>
